'use client';

/** WEBSITES — per-project site cards (registry + portfolio screenshots), click launches live site. */
import type { BusinessProject } from '@/lib/business-projects';
import { Glass, EmptyState, mono, display } from '@/future/primitives';

export function WebsitesSurface({ project }: { project: BusinessProject | null }) {
  const sites = project && project.sites !== 'factory' ? project.sites : [];
  if (!project) return <EmptyState what="NO PROJECT" action="Open websites from a project deck." />;
  if (project.sites === 'factory')
    return <EmptyState what="FACTORY SITES LIVE IN PORTFOLIO" action="BEAST → PORTFOLIO holds all factory sites." />;
  if (!sites.length) return <EmptyState what="NO SITES YET" action="No websites attached to this project." />;

  return (
    <div className="mx-auto max-w-5xl grid grid-cols-3 gap-4">
      {sites.map(s => (
        <a key={s.slug} href={`https://${s.domain}`} target="_blank" rel="noopener noreferrer" className="block group" style={{ textDecoration: 'none' }}>
          <Glass className="overflow-hidden p-0">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={`/portfolio-screenshots/${s.slug}.png`} alt={s.domain}
              className="w-full aspect-video object-cover object-top"
              style={{ opacity: .85, transition: 'opacity .25s ease' }}
              onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }} />
            <div className="p-4">
              <div style={{ ...display(26), color: 'var(--uif-t1)' }}>{s.domain}</div>
              <div className="mt-1" style={{ ...mono(15, '.2em'), color: 'var(--uif-t5)' }}>LAUNCH ↗</div>
            </div>
          </Glass>
        </a>
      ))}
    </div>
  );
}
